import React from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { FleetrifyModal } from "../Modal/modal";
import { FLEETRIFYROUTEPATH } from "../../routes/routesPath";
import { useAppDispatch } from "../../redux/services/store";
import { clearAuthUser } from "../../redux/slices/authSlice";

interface SubscriptionRequiredModalProps {
  isOpen: boolean;
}

export const SubscriptionRequiredModal: React.FC<SubscriptionRequiredModalProps> = ({ isOpen }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleSubscribeClick = () => {
    navigate(`${FLEETRIFYROUTEPATH.SETTINGS}?tab=subscription`);
  };

  const handleLoginClick = () => {
    // This isn't just a page link — the user has no active subscription, so
    // "Back to Login" should end the session, not leave a stale token cookie
    // behind (that stale session was showing the subscription reminder toast
    // on the login page itself).
    dispatch(clearAuthUser());
    Cookies.remove("token");
    localStorage.clear();
    sessionStorage.clear();
    navigate(FLEETRIFYROUTEPATH.LOGIN);
  };

  return (
    <FleetrifyModal
      isOpen={isOpen}
      title="Subscription Required"
      disableClose={true}
      enableOutsideClick={false}
      className="max-w-md"
      overlayClassName="z-50"
    >
      <div className="space-y-6 p-6">
        <div className="space-y-3">
          <p className="text-gray-700 text-sm leading-relaxed">
            Your subscription is currently inactive. To access all features and services, please activate your subscription.
          </p>
          <p className="text-gray-600 text-sm">
            Choose a plan that best fits your business needs and get started today.
          </p>
        </div>

        <div className="space-y-3">
          <button
            onClick={handleSubscribeClick}
            className="w-full bg-[#1E3A8A] text-white py-3 rounded-lg font-semibold hover:bg-[#1E40AF] transition-colors duration-300"
          >
            Go to Subscription
          </button>

          <button
            onClick={handleLoginClick}
            className="w-full bg-gray-100 text-gray-700 py-3 rounded-lg font-medium hover:bg-gray-200 transition-colors duration-300"
          >
            Back to Login
          </button>
        </div>

        <p className="text-xs text-gray-500 text-center">
          You will be able to access all features once your subscription is activated.
        </p>
      </div>
    </FleetrifyModal>
  );
};
